import { BrushedEdge } from './BrushedEdge';

export default BrushedEdge;
